import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset-advanced';

const mainBrandColor = '#F4892F';
const lightShades = '#FFFFFF';
const darkAccent = '#111111';
const darkShades = '#636567';

export const theme = {
  // It can be liberally applied to your layout as its main identity.
  mainBrandColor,
  // Accent colors can be used to bring attention to design elements
  // by contrasting with the rest of the palette.
  lightCreamAccent: '#FDEFE0',
  // Use this color as the background for your dark-on-light designs,
  // or the text color of an inverted design.
  lightShades,
  // Another accent color to consider. Not all colors have to be used -
  // sometimes a simple color scheme works best.
  darkAccent,
  // Use as the text color for dark-on-light designs,
  // or as the background for inverted designs.
  darkShades,

  // Background colors
  backgroundColor: mainBrandColor,
  backgroundColorLight: '#F0F0F0',
  backgroundLightAccent: '#E7E7E7',

  backgroundInputColor: lightShades,

  // Font sizes
  // fontSize: '16px',
  fontSizeBase: '20px',
  // fontSizeSmall: '28px',
  // fontSizeMedium: '40px', // is-size-2

  // Border colors
  borderColor: '#F0F0F0',

  // Text colors
  textColor: darkShades,
  textColorLite: lightShades,
  textGreyDark: darkShades,
  dangerColor: '#f44336',

  // FONTS
  primaryFontFamily: "'Montserrat', sans-serif", // using gatsby google fonts

  // Box shadows
  boxShadow: 'rgba(0,0,0,0.08) 0px 7px 18px',
};

const GlobalStyle = createGlobalStyle`
  ${reset};

  body {
    color: ${theme.textColor};
    letter-spacing: 0.7px;
    font-size: ${theme.fontSize};
    font-family: ${theme.primaryFontFamily} !important;
  }

   h1 {
    @media screen and (max-width: 768px) {
     font-size: ${theme.fontSizeBase} !important;
     line-height: 1.3 !important;
    }
  }

  .subtitle {
    color: ${theme.darkShades};
    line-height: 30px;
  }

  .has-text-grey-dark	{
    color: ${theme.textGreyDark} !important;
  }

  .has-background-light-tan {
    background-color: ${theme.backgroundColorLight} !important;
  }

  .has-text-orange	{
    color: ${theme.mainBrandColor} !important;
  }
  .is-split {
    color: ${(props) => props.theme.mainBrandColor};
  }

  .button.is-primary {
    background-color: ${theme.mainBrandColor};
    color: ${theme.textColorLite};
    transition: background-color 0.2s ease;
    border: 3px solid ${theme.borderColor};
    padding: 22px 14px;
    transition: background-color 0.4s ease;
    :hover {
      background-color: ${theme.darkShades};
      border: 3px solid ${theme.borderColor};
    }
  }

  .button.is-secondary {
    color: ${theme.textColorLite};
    background-color: transparent;
    border: 3px solid ${theme.borderColor};
    padding: 22px 14px;
    transition: background-color 0.4s ease;
    :hover {
      background-color: ${theme.mainBrandColor};
      border: 3px solid ${theme.borderColor};
      color: ${theme.textColorLite};
    }
  }

  .has-text-grey-dark	 {
    color: ${theme.textColorLite};
  }

  .is-borderless {
    border-radius: 0 !important;
  }
  .h-full {
    height:100%;
  }

  .content h1, .content h2, .content h3, .content h4, .content h5, .content h6 {
    color: ${theme.darkShades} !important;
    font-weight: 700;
  }
  .content a {
    color: ${theme.mainBrandColor} !important;
    font-weight: 600 !important;
    text-decoration: underline !important;
  }

  .content p ,.content li {
    line-height:30px !important;
  }
  strong {
    font-weight: 700;
    color: ${theme.mainBrandColor} !important;
  }
`;

export default GlobalStyle;
